'use strict';

(function () {
    'use strict';

    angular.module('documentRequests', ['ui.router', 'common']);
})();